<div class="table-container">
  <up-table class="table-width table-row-height" fixed-head fixed-foot>
    <table class="table-layout">
      <thead>
        <tr>
          @for (column of columns; track $index) {
          <th
            class="table-header-th"
            [class.col-actions]="column.value === 'actions'"
          >
            {{ column.key }}
          </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of rows; track $index; let rowIndex = $index) {
        <tr>
          @for (column of columns; track $index; let colIndex = $index) {
          <td
            [class.col-actions]="column.value === 'actions'"
            [class.nowrap]="column.value === 'actions'"
          >
            @if (column.value === 'actions') {
            <p class="centered p-style reset-spacing">
              <up-button
                type="button"
                button-style="icon"
                [id]="'action_btn_' + (row.id ?? rowIndex)"
                (click)="$event.stopPropagation()"
                aria-label="Row actions"
              >
                <up-icon name="more_vert"></up-icon>
              </up-button>

              <up-menu
                [for]="'action_btn_' + (row.id ?? rowIndex)"
                (menuItemSelected)="onActionMenu($event, row, rowIndex)"
              >
                @for (listItem of listItems; track $index) {
                <up-menu-item>{{ listItem }}</up-menu-item>
                }
              </up-menu>
            </p>
            } @if (column.value !== 'actions' && column.value !== 'rateComment')
            {
            <div class="wrap">{{ row[column.value] ?? '-' }}</div>
            } @if (column.value === 'rateComment') { @if (!row['rateComment']) {
            <ng-container>-</ng-container> } @if (row['rateComment']) {
            <div class="comment-wrap">{{ row['rateComment'] }}</div>
            } }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </up-table>
</div>
